import React from 'react';
import { STORY_CARDS } from '../config/constants';

const FilmStrip = ({ language }) => {
  const storyCards = STORY_CARDS;

  return (
    <div className="film-strip-container">
      <div className="gallery-track">
        {/* First set of images */}
        {storyCards.map((card) => (
          <div
            key={`first-${card.id}`}
            className="story-card"
            style={{ backgroundImage: `url(${card.image})` }}
          >
            <span>{card.tags[language]}</span>
          </div>
        ))}
        {/* Second identical set (for seamless looping) */}
        {storyCards.map((card) => (
          <div
            key={`second-${card.id}`}
            className="story-card"
            style={{ backgroundImage: `url(${card.image})` }}
          >
            <span>{card.tags[language]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilmStrip;